import React, { createContext, useContext, useState, ReactNode } from "react";

interface TripData {
  tripId: string;
  tripName: string;
  vendor: string;
  group: string;
  routeCode: string;
  stops: { stopAddress: string; lat: number; lng: number }[];
  routeName: string;
  routeLabel: string;
  deviceId: string;
  vehicleCode: string;
  vehicleName: string;
  vehicleLabel: string;
  driverCode: string;
  driverName: string;
  driverLabel: string;
  departureDate: string | null;
  departureTime: string;
  arrivalDate: string | null;
  arrivalTime: string;
  tripDeviation: boolean;
  tripDelay: boolean;
  approversEmail: string;
  comment: string;
}

interface TripContextProps {
  tripData: TripData;
  isTripDataSaved: boolean,
  setTripData: React.Dispatch<React.SetStateAction<TripData>>;
  setIsTripDataSaved: React.Dispatch<React.SetStateAction<boolean>>;
}

const defaultTripData: TripData = {
  tripId: "",
  tripName: "",
  vendor: "",
  group: "",
  deviceId: "",
  routeCode: "",
  routeName: "",
  stops: [],
  routeLabel: "",
  vehicleCode: "",
  vehicleName: "",
  vehicleLabel: "",
  driverCode: "",
  driverName: "",
  driverLabel: "",
  departureDate: null,
  departureTime: "",
  arrivalDate: null,
  arrivalTime: "",
  tripDeviation: false,
  tripDelay: false,
  approversEmail: "",
  comment: "",
};

const TripContext = createContext<TripContextProps | undefined>(undefined);

export const TripProvider = ({ children }: { children: ReactNode }) => {
  const [tripData, setTripData] = useState<TripData>(defaultTripData);
  const [isTripDataSaved, setIsTripDataSaved] = useState<boolean>(false);
  return (
    <TripContext.Provider value={{ tripData, setTripData, isTripDataSaved, setIsTripDataSaved }}>
      {children}
    </TripContext.Provider>
  );
};

export const useTripContext = () => {
  const context = useContext(TripContext);
  if (!context) {
    throw new Error("useTripContext must be used within a TripProvider");
  }
  return context;
};
